import { getSupabase } from './supabase'
import { useAuthStore } from '@/stores/auth'

const MAX_FILE_SIZE = 2 * 1024 * 1024 // 2MB
const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']

export async function uploadProfileImage(file: File): Promise<string> {
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error('Please upload a JPEG, PNG, GIF, or WebP image.')
  }

  if (file.size > MAX_FILE_SIZE) {
    throw new Error('Image must be under 2MB.')
  }

  const user = useAuthStore.getState().user
  if (!user) {
    throw new Error('You must be logged in to upload images.')
  }

  const ext = file.name.split('.').pop() || 'jpg'
  const path = `${user.id}/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`

  const supabase = getSupabase()
  const { error } = await supabase.storage
    .from('profile-images')
    .upload(path, file, { upsert: true })

  if (error) {
    throw new Error(`Upload failed: ${error.message}`)
  }

  const { data: urlData } = supabase.storage
    .from('profile-images')
    .getPublicUrl(path)

  return urlData.publicUrl
}
